import React, {useState} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faClose,
    faCoins,
    faFire,
    faGear,
    faTrophy,
    faUniversity,
    faUserCircle
} from '@fortawesome/free-solid-svg-icons';
import ButtonLink from '../elements/ButtonLink';
import Button from "../elements/Button";
import {Link} from 'react-router-dom';

import {useAuth} from "../../context/AuthProvider";


const Account = ({
                     className
                 }) => {

    const {
        user,
        isAuthenticated,
        loading,
        logout
    } = useAuth();

    const streak = user?.streak;
    const xp = user?.xp;
    const credit = user?.credit;

    const [viewModal, setViewModal] = useState(false);


    const handleClick = () => {

        setViewModal(prev => !prev);

    };


    const handleLogout = async () => {

        await logout();

        setViewModal(false);

    };


    const menu = [
        {
            text: 'دوره‌های من',
            link: '/fa/account/course',
            icon: faUniversity
        },
    ];


    /*
     * AuthProvider is still checking the HttpOnly
     * session cookie.
     *
     * Don't show either "ورود" or the account UI
     * until we know the authentication state.
     */
    if (loading) {
        return null;
    }


    return (
        <div
            className={`absolute left-5 top-3 md:top-0 md:left-0 md:relative text-md ${className || ''}`}
        >

            {isAuthenticated ? (

                viewModal ? (

                    <>
                        <div className="hidden md:flex items-center">

                            {/* Streak */}
                            <div
                                className="flex items-center gap-x-3 ml-8 cursor-pointer"
                            >
                                <span className="block text-lg text-gray-700 font-bold">
                                    {streak}
                                </span>

                                <FontAwesomeIcon
                                    icon={faFire}
                                    size="lg"
                                />
                            </div>


                            {/* Credits */}
                            <div
                                className="hidden md:flex items-center gap-x-3 ml-8 cursor-pointer"
                            >
                                <span className="block text-lg text-gray-700 font-bold">
                                    {credit}
                                </span>

                                <FontAwesomeIcon
                                    icon={faCoins}
                                    size="lg"
                                />
                            </div>

                            {/* XP */}
                            <div
                                className="hidden md:flex items-center gap-x-3 ml-8 cursor-pointer"
                            >
                                <span className="block text-lg text-gray-700 font-bold">
                                    {xp}
                                </span>

                                <FontAwesomeIcon
                                    icon={faCoins}
                                    size="lg"
                                />
                            </div>


                            {/* Close account menu */}
                            <Button
                                onClick={handleClick}
                                className="mr-auto pt-2 z-2 rounded-md bg-light-primary py-3 px-5 w-fill gap-2 bg-transparent"
                            >
                                <FontAwesomeIcon
                                    icon={faClose}
                                    className="h-5"
                                />
                            </Button>

                        </div>
                    </>

                ) : (

                    <div className="flex items-center">

                        {/* Streak */}
                        <div
                            className="hidden md:flex items-center gap-x-3 ml-8 cursor-pointer"
                        >
                            <span className="block text-lg text-gray-700 font-bold">
                                {streak}
                            </span>

                            <FontAwesomeIcon
                                icon={faFire}
                                size="lg"
                            />
                        </div>


                        {/* Credits */}
                        <div
                            className="hidden items-center md:flex gap-x-3 ml-8 cursor-pointer"
                        >
                            <span className="block text-lg text-gray-700 font-bold">
                                {credit}
                            </span>

                            <FontAwesomeIcon
                                icon={faCoins}
                                size="lg"
                            />
                        </div>

                        {/* XP */}
                        <div
                            className="hidden items-center md:flex gap-x-3 ml-8 cursor-pointer"
                        >
                            <span className="block text-lg text-gray-700 font-bold">
                                {xp}
                            </span>

                            <FontAwesomeIcon
                                icon={faCoins}
                                size="lg"
                            />
                        </div>


                        {/* Account button */}
                        <Button
                            onClick={handleClick}
                            className="mr-auto pt-2 z-2 rounded-md bg-light-primary py-3 px-5 w-fill gap-2 bg-transparent"
                        >
                            <FontAwesomeIcon
                                icon={faUserCircle}
                                className="h-5"
                            />
                        </Button>

                    </div>

                )

            ) : (

                <ButtonLink
                    to="/fa/auth"
                    className="mr-auto rounded-md bg-light-primary text-white text-lg gap-x-3 w-fill"
                >
                    <span className="hidden md:block">ورود<span className="mx-1">/</span>ثبت‌نام</span>

                    <FontAwesomeIcon
                        icon={faUserCircle}
                        size="xl"
                        className="block md:hidden"
                    />
                </ButtonLink>

            )}


            {/* Account dropdown */}
            {viewModal && isAuthenticated && (

                <div
                    className="w-64 h-fit rounded-md border-4 border-gray-200 bg-gray-100 absolute left-0 top-20 z-1"
                >

                    {/* User */}
                    <div className="px-5 py-4 border-b-2 border-gray-200">

                        <span className="font-bold text-gray-700">
                            {user?.name}
                        </span>

                    </div>


                    {/* Menu */}
                    <ul className="list-none w-full">

                        {menu.map((item, index) => (

                            <li
                                key={index}
                                className="flex transition justify-center items-center first:rounded-t-md last:border-b-0 last:rounded-b-md p-5 cursor-pointer border-b-2 border-gray-200 m-0 hover:bg-gray-200"
                            >

                                <Link to={item.link}>

                                    <FontAwesomeIcon
                                        icon={item.icon}
                                        className="ml-3"
                                        size="lg"
                                    />

                                    <span>
                                        {item.text}
                                    </span>

                                </Link>

                            </li>

                        ))}


                        {/* Logout */}
                        <li
                            className="p-5 text-center cursor-pointer hover:bg-gray-200 text-red-500"
                            onClick={handleLogout}
                        >
                            خروج
                        </li>

                    </ul>

                </div>

            )}

        </div>
    );
};


export default Account;